import { ButtonDialog } from '@autopass-web/mochi-component';

interface PaymentPriceRateHintDialogProps {
  isOpen: boolean;
  onButtonClick: () => void;
  messages: string[];
}

export const PaymentPriceRateHintDialog = ({
  messages,
  isOpen,
  onButtonClick,
}: PaymentPriceRateHintDialogProps) => (
  <ButtonDialog
    show={isOpen}
    title="停車期間臨停計費方式"
    message={
      <div>
        {messages.map((x) => (
          <p key={x}>
            {x}
            <br />
          </p>
        ))}
        <br />
        ※如有付款金額計費疑問，請洽停車場管理員。(例：跨月租時段免費、店家優惠折抵明細)
      </div>
    }
    buttonList={[
      {
        theme: 'positive',
        content: '返回',
        onClick: onButtonClick,
        beLoading: false,
      },
    ]}
  />
);
